const TECHNICAL_EVENTS = new Set([
  "next-cycle-number",
  "pusher:connection_established",
  "pusher:subscription_succeeded",
  "pusher_internal:subscription_succeeded",
]);

const ENTITY_LABELS = {
  planned_cycle: "zaplanowany cykl",
  task: "zadanie",
  assortment: "asortyment",
  freeze_dryer: "liofilizator",
  sheet: "arkusz",
};

function entityLabel(entity = "") {
  if (ENTITY_LABELS[entity]) return ENTITY_LABELS[entity];
  if (entity.startsWith("warehouse_")) return "pozycję magazynową";
  if (entity.startsWith("catalog_")) return "pozycję słownika";
  if (entity.includes("meal") || entity.includes("dish")) return "dane planowania dań";
  return "dane";
}

function actionMessage(action, label) {
  if (action === "created") return `Dodano ${label}.`;
  if (action === "deleted") return `Usunięto ${label}.`;
  return `Zaktualizowano ${label}.`;
}

export function createRealtimeToastNotifier({
  notify,
  maxEventIds = 500,
  notifyApplicationEvents = false,
  schedule = (callback) => setTimeout(callback, 300),
}) {
  const seenEventIds = new Set();
  let previousState = "idle";
  let pendingEvents = [];
  let notificationScheduled = false;

  function remember(eventId) {
    if (!eventId) return true;
    if (seenEventIds.has(eventId)) return false;
    seenEventIds.add(eventId);
    if (seenEventIds.size > maxEventIds) {
      seenEventIds.delete(seenEventIds.values().next().value);
    }
    return true;
  }

  function flushEvents() {
    const events = pendingEvents;
    pendingEvents = [];
    notificationScheduled = false;
    if (!events.length) return;

    const detail = events.length === 1
      ? actionMessage(events[0].action, entityLabel(events[0].entity))
      : `Dane zostały odświeżone (${events.length} zmiany).`;
    notify({
      severity: "info",
      summary: "Aktualizacja realtime",
      detail,
      life: 3500,
    });
  }

  return {
    onState(state) {
      if (state === "connected" && previousState !== "connected") {
        notify({
          severity: "success",
          summary: "Połączenie realtime aktywne",
          detail: "Automatyczne odświeżanie danych działa.",
          life: 3000,
        });
      }
      previousState = state;
    },
    onEvent(eventName, payload = {}) {
      if (
        !notifyApplicationEvents ||
        !eventName ||
        eventName.startsWith("pusher:") ||
        eventName.startsWith("pusher_internal:") ||
        TECHNICAL_EVENTS.has(eventName) ||
        !payload.event_id ||
        !payload.entity ||
        !remember(payload.event_id)
      ) return;

      pendingEvents.push(payload);
      if (!notificationScheduled) {
        notificationScheduled = true;
        schedule(flushEvents);
      }
    },
  };
}
